<template>
  <div class="container">
    <div class="header-title">
        <span style="position: absolute;left: 2.2rem;top: 1.5rem;" @click="backUp"><van-icon name="revoke"></van-icon></span>
    转账中心
    </div>
    <div class="sub-continner" style="margin-top: 7.8rem;">
    <div class="main-card">
        <div class="main-card-content">
          方法：请填好对方平台账号和金额，即可直接转账！
          <div>提示：此功能方便出售USDT帮助用户省平台手续费。(线下交易需警惕， 切勿上当受骗)</div>
        </div>
      </div>
    <div class="from-continner">
      <van-form @submit="onSubmit">
        <van-field
          v-model="ustdAddress"
          name="ustd地址"
          label="对方账号："
          placeholder="对方账号"
          :rules="[{ required: true, message: '请填写对方账号' }]"
        ></van-field>
        <van-field
          v-model="confirmUstdAddr"
          name="ustd确认地址"
          label="确认账号："
          placeholder="确认账号"
          :rules="[{ required: true, message: '请填写对方账号' }]"
        ></van-field>
        <van-field
          v-model="transferMoney"
          name="转账金额"
          label="转账金额："
          placeholder="转账金额"
          :rules="[{ required: true, message: '请填写转账金额' }]"
        ></van-field>
        <div style="margin: 16px;width: 100%;display: flex;justify-content: center;">
          <van-button round block type="info" native-type="submit"
            >确认转账</van-button
          >
        </div>
      </van-form>
    </div>
    </div>
  </div>
</template>
<script>
import { transferMoney } from '../../api/system/sys_backInfo';
import { Dialog, Toast } from 'vant';
import { mixins } from '../../mixins/mixins';

export default {
  mixins: [mixins],
  data() {
    return {
      ustdAddress: "",
      confirmUstdAddr: "",
      transferMoney: 0,
    };
  },
  mounted() {
    this.$emit("titleChange", "转账");
    // 键盘收起时恢复页面滚动位置，确保顶部返回按钮可见
    document.addEventListener('focusout', this.handleFocusOut);
  },
  beforeDestroy() {
    document.removeEventListener('focusout', this.handleFocusOut);
  },
  methods: {
    // 所有输入框失去焦点后，将页面滚动回顶部
    handleFocusOut() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$el;
          const activeEl = document.activeElement;
          if (!activeEl || (activeEl.tagName !== 'INPUT' && activeEl.tagName !== 'TEXTAREA')) {
            container.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 300);
      });
    },
    onSubmit(values) {
      console.log("submit", values);
      transferMoney(this.ustdAddress, this.transferMoney).then((res)=>{
        if(res.success){
          Dialog.alert({
            title: '转账结果',
            message: '转账成功',
          }).then(() => {
            // on close
            this.$router.back();
          });
        }
      }).catch((err) => {
          Toast.fail(err.message);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
  .from-continner{
    margin-top: 15px;
    padding-bottom: 30px;

    // 防止iOS键盘弹出时输入框自动放大
    ::v-deep .van-field__control {
      font-size: 16px;
    }

    // 确保输入框标签也有合适的字号，避免键盘弹出时布局偏移
    ::v-deep .van-field__label {
      font-size: 16px;
    }

    button{
      width: 280px;
      color: #fff;
      background: linear-gradient(to right, #3333ff, #3392ff);
    }
  }
</style>
